import { render } from "./TeacherTabs.vue?vue&type=template&id=a6286e6c"
import script from "./TeacherTabs.vue?vue&type=script&lang=js"
export * from "./TeacherTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__